(() => {
  if (window.howlFinishSwitchV31) return;
  window.howlFinishSwitchV31 = true;
  let pending;
  let requestNumber = 0;
  const select = async (url, { push = true, focus = true } = {}) => {
    const current = document.querySelector('main product-info[id^="MainProduct-"]');
    if (!current) return;
    pending?.abort();
    const controller = new AbortController();
    pending = controller;
    const number = ++requestNumber;
    const main = current.closest('main');
    const previousY = window.scrollY;
    const quantity = current.querySelector('input[name="quantity"]')?.value;
    main.setAttribute('aria-busy', 'true');
    current.querySelectorAll('product-form, .shopify-payment-button, shopify-accelerated-checkout').forEach(node => {
      if (!node.hasAttribute('data-howl-was-inert')) node.dataset.howlWasInert = String(node.inert);
      node.inert = true;
    });
    current.querySelectorAll('button[name="add"], .shopify-payment-button button, howl-sticky-purchase button').forEach(button => {
      if (!button.hasAttribute('data-howl-was-disabled')) button.dataset.howlWasDisabled = String(button.disabled);
      button.disabled = true;
    });
    document.querySelectorAll('howl-sticky-purchase button').forEach(button => {if (!button.hasAttribute('data-howl-was-disabled')) button.dataset.howlWasDisabled = String(button.disabled); button.disabled = true;});
    let requestTimeoutId;
    try {
      const responseText = await Promise.race([
        fetch(url.href, { signal: controller.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(response => {
          if (!response.ok) throw new Error('Finish unavailable');
          return response.text();
        }),
        new Promise((_, reject) => {
          requestTimeoutId = setTimeout(() => {
            reject(new Error('Finish request timed out'));
            controller.abort();
          }, 30000);
        }),
      ]);
      const incoming = new DOMParser().parseFromString(responseText, 'text/html');
      const next = incoming.querySelector('main product-info[id^="MainProduct-"]');
      if (!next || !next.querySelector('form[action*="/cart/add"] input[name="id"]')) throw new Error('Incomplete product');
      if (number !== requestNumber) return;
      const nextMain = incoming.querySelector('main');
      nextMain.querySelectorAll('.scroll-trigger').forEach(node => node.classList.add('scroll-trigger--cancel'));
      main.replaceWith(nextMain);
      const nextQuantity = next.querySelector('input[name="quantity"]');
      if (nextQuantity && quantity) {
        const min = Number(nextQuantity.min) || 1;
        const max = Number(nextQuantity.max) || Infinity;
        const step = Number(nextQuantity.step) || 1;
        nextQuantity.value = String(Math.min(max, Math.max(min, min + Math.floor((Number(quantity) - min) / step) * step)));
      }
      nextQuantity?.dispatchEvent(new Event('change', { bubbles: true }));
      for (const selector of ['title', 'link[rel="canonical"]', 'meta[name="description"]', 'meta[property^="og:"]', 'meta[name^="twitter:"]']) {
        document.head.querySelectorAll(selector).forEach(node => node.remove());
        incoming.head.querySelectorAll(selector).forEach(node => document.head.append(node.cloneNode(true)));
      }
      if (push) history.pushState({ howlFinish: true }, '', url.pathname + url.search + url.hash);
      window.Shopify?.PaymentButton?.init();
      window.ProductModel?.loadShopifyXR?.();
      nextMain.removeAttribute('aria-busy');
      window.scrollTo({ top: previousY, behavior: 'instant' });
      if (focus) next.querySelector('[data-howl-finish-link][aria-current="page"]')?.focus({ preventScroll: true });
      document.dispatchEvent(new CustomEvent('howl:finish-change', { detail: { url: url.href, productId: next.dataset.productId } }));
    } catch (error) {
      if (error.name !== 'AbortError' && number === requestNumber) {
        if (!push) location.reload();
        else location.assign(url.href);
      }
    } finally {
      clearTimeout(requestTimeoutId);
      if (pending === controller) pending = null;
      if (number === requestNumber) {
        main.removeAttribute('aria-busy');
        document.querySelectorAll('[data-howl-was-inert]').forEach(node => {
          node.inert = node.dataset.howlWasInert === 'true';
          delete node.dataset.howlWasInert;
        });
        document.querySelectorAll('[data-howl-was-disabled]').forEach(button => {
          button.disabled = button.dataset.howlWasDisabled === 'true';
          delete button.dataset.howlWasDisabled;
        });
      }
    }
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-howl-finish-link]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    const url = new URL(link.href);
    if (url.origin !== location.origin) return;
    if (link.hasAttribute('aria-current') && !pending) {
      const currentUrl = new URL(location.href);
      if (url.pathname === currentUrl.pathname && url.searchParams.get('variant') === currentUrl.searchParams.get('variant')) {
        event.preventDefault();
        return;
      }
    }
    event.preventDefault();
    select(url);
  });
  window.addEventListener('popstate', () => {
    if (document.querySelector('main product-info[id^="MainProduct-"]')) select(new URL(location.href), { push: false, focus: false });
  });
})();
